/**
 * Стандартный onClick кнопки футера url-окна — алиас «reload-content»: повторно подгрузить содержимое открытого окна.
 *
 * Плагин open-modal-url.js (1 файл — 1 функция). Вызывается с аргументами (button, config): button — нажатая кнопка
 * (jQuery), здесь не используется; config — опции окна. Ставит крутилку-плейсхолдер и повторяет GET по уже
 * разрешённому config.url через load-content.
 */
window.openModalWindowFunctions["reload-content"] = function (element, config) {
    config.modal.find(".modal-body").html('<div class="text-center py-4"><div class="spinner-border text-primary" role="status"></div></div>');
    window.openModalWindowFunctions["load-content"](element, config);
};
